import { testIf } from '../validationFunctions';
import { cleanArray } from '../../mergeFunctions';
import { successState, formatResults } from '../validationHelpers';

export const validateTeamForm = ({ data, setNotificationText }) => {
  const testResults = cleanArray(testIf('empty')(data, ['teamName']));
  if (testResults.length === 0) return successState(setNotificationText);
  setNotificationText(formatResults(testResults));
};
